/*
 * skill-card 技能卡
 * Schema: { name, display_name, description?, icon?, category?, status }
 */
import React from 'react'
import { tryParseJson, SkillCardData, SkillStatus } from './types'
import { useInvalidBlockWarning } from './useInvalidBlockWarning'
import './SkillCardBlock.scss'

interface SkillCardBlockProps {
  code: string
}

const STATUS_CONFIG: Record<SkillStatus, { label: string; className: string }> =
  {
    created: { label: '已创建', className: 'aiClerk-block-skill__status--ok' },
    updated: {
      label: '已更新',
      className: 'aiClerk-block-skill__status--info'
    },
    disabled: {
      label: '已停用',
      className: 'aiClerk-block-skill__status--gray'
    },
    deleted: { label: '已删除', className: 'aiClerk-block-skill__status--err' }
  }

export const SkillCardBlock: React.FC<SkillCardBlockProps> = ({ code }) => {
  const data = tryParseJson<SkillCardData>(code)

  // 流式中 JSON 未收齐时 silent 不渲染，避免闪"技能卡数据无效"（对齐 FileListBlock）；
  // 流式结束后仍无效 → useInvalidBlockWarning 会 console.warn 留排查线索
  const valid = !!data && !!data.name && !!data.display_name
  useInvalidBlockWarning('skill-card', code, valid)
  if (!data || !data.name || !data.display_name) {
    return null
  }

  const cfg = STATUS_CONFIG[data.status] || STATUS_CONFIG.created

  return (
    <div className="aiClerk-block-skill">
      <div className="aiClerk-block-skill__icon">{data.icon || '✨'}</div>
      <div className="aiClerk-block-skill__body">
        <div className="aiClerk-block-skill__head">
          <span className="aiClerk-block-skill__name">{data.display_name}</span>
          <span className={`aiClerk-block-skill__status ${cfg.className}`}>
            {cfg.label}
          </span>
        </div>
        {data.description && (
          <div className="aiClerk-block-skill__desc">{data.description}</div>
        )}
        <div className="aiClerk-block-skill__meta">
          <code>{data.name}</code>
          {data.category && (
            <span className="aiClerk-block-skill__cat">{data.category}</span>
          )}
        </div>
      </div>
    </div>
  )
}
